import React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react";
import { useIsLogin } from "@/openbaas";
import { useIsAdmin } from "@/context/admin/use-is-admin";
export default function BottonNavigation() {
  const router = useRouter();
  const { asPath } = router;
  const { isLogin } = useIsLogin();
  const isAdmin = useIsAdmin();
  const items = [
    { href: "/", icon: "ic:round-home", label: "Home" },
    // { href: "/report", icon: "ic:round-report", label: "Reportes" },
    {
      href: "/account",
      icon: "mdi:account-circle-outline",
      label: isLogin ? "Perfil" : "Signin",
    },
    ...(isAdmin
      ? [{ href: "/admin", icon: "ic:round-settings", label: "Admin" }]
      : []),
  ].filter(Boolean);

  return (
    <div className="fixed bottom-0 left-0 w-full z-10">
      <div className="p-1 shadow-md flex justify-around bg-white max-w-[500px] mx-auto border-t">
        {items.map((item) => {
          const isActive = asPath === item.href;
          const activeClass = isActive ? "text-[#f15a24]" : "text-zinc-400";

          return (
            <Link key={item.href} href={item.href}>
              <motion.button
                whileTap={{ scale: 0.9 }}
                className={`flex flex-col items-center justify-center px-3 py-1 rounded-md ${activeClass}`}
              >
                <Icon icon={item.icon} className="h-6 w-6" />
                <p className="text-xs">{item.label}</p>
              </motion.button>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
